import { Outlet } from 'react-router-dom'
import { AppShell } from '@rb/ui'
import { getCurrentUser } from '../lib/auth'

interface AppShellLayoutProps {
  navMode: 'client' | 'admin'
}

export function AppShellLayout({ navMode }: AppShellLayoutProps) {
  const user = getCurrentUser()
  const shellUser = user ? { name: user.name, role: user.role } : null
  return (
    <AppShell navMode={navMode} user={shellUser}>
      <Outlet />
    </AppShell>
  )
}
